import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';

import PrimarySocials from './PrimarySocials';
import Divider from './Form/Divider';

const RegistrationSocials = ({allowedSocials, containerClassName = ''}) => (
  <div className={classNames(containerClassName, 'divider__parent')}>
    <PrimarySocials socials={allowedSocials} type="registration" />
    <Divider />
  </div>
);

RegistrationSocials.propTypes = {
  allowedSocials: PropTypes.array.isRequired,
  containerClassName: PropTypes.string
};

function mapStateToProps(state) {
  const {socialLinks} = state.xl;
  return {
    allowedSocials: socialLinks.primary
  };
}

export default connect(mapStateToProps)(RegistrationSocials);



// WEBPACK FOOTER //
// ./components/RegistrationSocials.jsx